import { setGlobal } from "reactn"

export const initGlobal = () =>
  setGlobal({
    apiStore: {},
  })
